module.exports = __webpack_public_path__ + "static/media/total-chw.49a7129e.jpg";